import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import type { PlatformActivationPreviewDto, PlatformEnrollmentStartDto } from '@intelimove/contracts';
import { BrandLogo } from '../components/BrandLogo';
import { platformAdapter } from '../data/platform';
import { AuthenticatorSetup, RecoveryCodesReveal, apiMessage } from './shared';

export function PlatformActivation() {
  const navigate = useNavigate();
  const [token] = useState(() => new URLSearchParams(location.hash.slice(1)).get('token') ?? '');
  const [preview, setPreview] = useState<PlatformActivationPreviewDto | null>(null);
  const [start, setStart] = useState<PlatformEnrollmentStartDto | null>(null);
  const [codes, setCodes] = useState<string[] | null>(null);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    history.replaceState(null, '', location.pathname);
    if (!token) { setError('Link inválido ou incompleto.'); return; }
    platformAdapter.inspectActivation(token).then(setPreview).catch((e) => setError(apiMessage(e, 'Link inválido ou expirado.')));
  }, [token]);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (password.length < 10) { setError('A senha deve ter pelo menos 10 caracteres.'); return; }
    if (password !== confirm) { setError('As senhas não conferem.'); return; }
    setBusy(true); setError(null);
    try { setStart((await platformAdapter.completeActivation(token, password)).start); setPassword(''); setConfirm(''); }
    catch (err) { setError(apiMessage(err, 'Não foi possível concluir a ativação.')); setBusy(false); }
  };
  return <main className="onboarding"><BrandLogo variant="public"/><section className="card source-form pa-activation">
    <span className="eyebrow">Administração da plataforma</span>
    {codes ? <><h1 className="h2">Acesso protegido</h1><RecoveryCodesReveal codes={codes} doneLabel="Ir para o acesso" onDone={() => navigate('/admin/plataforma', { replace: true })}/></>
      : start ? <><h1 className="h2">Cadastre seu autenticador</h1><p>Este passo é obrigatório. O operador não recebe nem guarda o segredo.</p>
        <AuthenticatorSetup start={start} onConfirm={async (code) => setCodes((await platformAdapter.confirmEnrollment(start.enrollmentId, code)).recoveryCodes)}/></>
      : preview ? <><h1 className="h2">{preview.kind === 'ACTIVATION' ? 'Ativar identidade administrativa' : 'Recuperar acesso administrativo'}</h1>
        <p>Olá, <b>{preview.name}</b>. Defina sua senha. Em seguida você cadastrará o segundo fator e receberá códigos de recuperação.</p>
        <form className="form" onSubmit={submit} noValidate>{error&&<div className="form-error" role="alert">{error}</div>}
          <div className="field"><label htmlFor="pa-new-password">Nova senha</label><input id="pa-new-password" type="password" autoComplete="new-password" minLength={10} required value={password} onChange={(e)=>setPassword(e.target.value)}/></div>
          <div className="field"><label htmlFor="pa-confirm-password">Confirmar senha</label><input id="pa-confirm-password" type="password" autoComplete="new-password" minLength={10} required value={confirm} onChange={(e)=>setConfirm(e.target.value)}/></div>
          <button className="primary" disabled={busy}>{busy?'Protegendo acesso…':'Definir senha e continuar'}</button>
        </form></>
      : <><h1 className="h2">Validando o link</h1>{error?<div className="form-error" role="alert">{error}</div>:<p>Aguarde…</p>}</>}
  </section></main>;
}
